import { Flex, type FlexProps } from '@companydotcom/potion';
import { motion } from 'framer-motion';

export const MotionFlex = motion<FlexProps>(Flex);
